import {ViewBase} from "@/rawdogjs/src/core/viewBase";
import {IView} from "@/rawdogjs/src/interfaces/IView";
import {SignUpPresenter} from "./signUpPresenter";
import {Router} from "@/rawdogjs/src/router";
import {ParcelDependencyContainer} from "@/rawdogjs/src/core/ParcelDependencyContainer";

export class SignUpView extends ViewBase implements IView {

    public _presenter: SignUpPresenter;


    constructor(viewName: string, router: Router, dependencyContainer: ParcelDependencyContainer, presenter: SignUpPresenter) {
        super(viewName, router, dependencyContainer);
        this._presenter = presenter;
    }

    set isPublicKeyInputEnabled(isEnabled: boolean) {
        (document.getElementById('public-key') as any).style.display =  isEnabled ? 'block' : 'none';
        (document.querySelector('label[for="public-key"]') as any).style.display =  isEnabled ? 'block' : 'none';
    }

    set isSignUpButtonEnable(isEnabled: boolean) {
        if (isEnabled)
            (document.getElementById('btn-sign-up') as any).classList.remove("disabled");
        else
            (document.getElementById('btn-sign-up') as any).classList.add("disabled");

        (document.getElementById('btn-sign-up') as any).disabled = !isEnabled; //flip
    }

    set isChallengeInputEnabled(isEnabled: boolean) {
        // dom is counter intuitiveness 
        (document.getElementById('challenge') as any).disabled = (!isEnabled);
    }

    set isHandleInputEnabled(isEnabled: boolean) {
        // dom is counter intuitiveness 
        (document.getElementById('handle') as any).disabled = (!isEnabled);
    }
    
    set isExistingHandleLoading(isEnabled: boolean) {
        (document.getElementById('is-existing-handle-loading') as any).style.display = isEnabled ? 'block' : 'none';
    }

    set isHandleAvailable(isEnabled: boolean) {
        (document.getElementById('handle-is-available') as any).style.display = isEnabled ? 'block' : 'none';
        (document.getElementById('handle-is-available') as any).innerHTML = `✅ Handle "${this.handle}" is available.`;
        // (document.getElementById('handle-is-not-available') as any).style.display = !isEnabled ? 'block' : 'none';
    }


    get handle() {
        return this.getValueById('handle');
    }

    set handle(handle: string) {
        this.setValueById('handle', handle);
    }

    get email() {
        return this.getValueById('email');
    }

    set email(email) {
        this.setValueById('email', email);
    }

    get firstName() {
        return this.getValueById('first-name');
    }

    set firstName(firstName) {
        this.setValueById('first-name', firstName);
    }

    get lastName() {
        return this.getValueById('last-name');
    }

    set lastName(lastName) {
        this.setValueById('last-name', lastName);
    }

    get publicKey() {
        return this.getValueById('public-key');
    }

    set publicKey(publicKey) {
        this.setValueById('public-key', publicKey);
    }
    
    get publicKeyId(){
        return this.getValueById('public-key-id');
    }
    
    set publicKeyId(publicKeyId){
        this.setValueById('public-key-id', publicKeyId);
    }

    get challenge() {
        return this.getValueById('challenge');
    }

    set challenge(challenge) {
        this.setValueById('challenge', challenge);
    }

    get password() {
        return this.getValueById('password');
    }

    set password(password) {
        this.setValueById('password', password);
    }

    setPresenter(presenter: SignUpPresenter) {
        this._presenter = presenter;
    }

    render(): void {
    }


}